import React from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';

export default function TabletPortrait({ children, invert }) {
    const query = invert ? '(max-width: 600px) or (min-width: 901px)' : '(min-width: 601px) and (max-width: 900px)';
    return <MediaQuery query={query}>{children}</MediaQuery>;
}
TabletPortrait.propTypes = {
    invert: PropTypes.bool
};
TabletPortrait.defaultProps = {
    invert: false
};
